import useRouter from "common/hooks/use-router";
import { useCallback } from "react";
import CrudEdit from "common/components/Crud/CrudEdit";
import AdminForm from "./AdminForm";

function Admin() {
  const router = useRouter();

  const id = router.query.id as string;

  const back = useCallback(() => {
    router.navigate("/administrators");
  }, [router]);

  return (
    <CrudEdit collectionName="users" id={id} Form={AdminForm} onBack={back} />
  );
}

export default Admin;
